<template>
  <el-row style="margin: 10px ;">
    <el-col :span="4">订单数量：{{parentData.cnt}}</el-col>
    <el-col :span="10">原产品：{{parentData['rebuild_product.name@from_product_id']}}</el-col>
    <el-col :span="10">目标产品：{{parentData['rebuild_product.name@to_product_id']}}</el-col>
  </el-row>
  <el-row class="box">
    <el-col :span="2">物料类型</el-col>
    <el-col :span="4">物料编码</el-col>
    <el-col :span="6">物料名称</el-col>
    <el-col :span="2">总需求数量</el-col>
    <el-col :span="2">采购单号</el-col>
    <el-col :span="2">计划采购数量</el-col>
    <el-col :span="2">实际采购数量</el-col>
    <el-col :span="2">采购接收数量</el-col>
    <el-col :span="2">接收NG数量</el-col>

  </el-row>
  <el-row v-for="item in materialItemList" :key="item.id" class="row" >
    <el-col :span="2" style="text-align: center">{{item.typeName}}</el-col>
    <el-col :span="4">{{item.code}}</el-col>
    <el-col :span="6">{{item.name}}</el-col>
    <el-col :span="2" style="text-align: center">{{item.demandCnt}}</el-col>
    <el-col :span="2" style="text-align: center">{{item.purchase_id}}</el-col>
    <el-col :span="2" style="text-align: center">{{item.plan_purchase_cnt}}</el-col>
    <el-col :span="2" style="text-align: center">{{item.really_purchase_cnt}}</el-col>
    <el-col :span="2" style="text-align: center">{{item.receive_cnt}}</el-col>
    <el-col :span="2" style="text-align: center">{{item.receive_ng_cnt}}</el-col>
  </el-row>
</template>

<script>
export default {
  name: "OrderPurchaseDetail",
  props: {
    parentData: {
      type: Object,
      default() {
        return {}
      }
    },
  },

  data(){
    return {
      materialItemList:[],

    }

  },
  created() {
    this.getPurchaseMaterialDetail()

  },
  methods: {
    async getPurchaseMaterialDetail(){
      this.materialItemList = await this.$http('rebuildPurchaseService.getPurchaseMaterialDetail',{order_id:this.parentData.order_id})

    }

  }
}
</script>

<style scoped>
.box {
  background-color: lightgray;
  height: 35px;
  line-height: 35px;
  text-align: center;
}

.row {
  margin-top: 15px;
  padding: 0;
}

</style>